/**
 * Centralized API configuration for the application.
 * Dynamically determines the API URL based on environment variables and deployment context.
 */

const envApiUrlRaw = process.env.REACT_APP_API_URL || '';
const envApiUrl = envApiUrlRaw.trim().replace(/\/+$/, '');
const isBrowser = typeof window !== 'undefined';
const hostname = isBrowser ? window.location.hostname : '';
// The packaged Electron app loads the build via file://, which has no hostname.
// Treat that the same as localhost — there is no "deployed origin" to fall back to.
const isFileProtocol = isBrowser && window.location.protocol === 'file:';
const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1' || isFileProtocol;
const envPointsToLocal =
  /localhost|127\.0\.0\.1/i.test(envApiUrl);

// Prevent accidental production *web* builds from using localhost API URLs.
const shouldIgnoreEnvUrl = process.env.NODE_ENV === 'production' && !isLocalHost && envPointsToLocal;

let API_BASE_URL = '';

if (envApiUrl && !shouldIgnoreEnvUrl) {
  API_BASE_URL = envApiUrl;
} else if (process.env.NODE_ENV !== 'production') {
  API_BASE_URL = 'http://localhost:5010';
} else if (isFileProtocol) {
  API_BASE_URL = 'http://localhost:5010';
} else if (isBrowser) {
  API_BASE_URL = window.location.origin;
}

if (shouldIgnoreEnvUrl) {
  // eslint-disable-next-line no-console
  console.warn(
    '[apiConfig] Ignoring localhost REACT_APP_API_URL in production build. Using deployed origin instead.'
  );
}

export default API_BASE_URL;
